import React from "react";
import {
  StyledDemoAccordion,
  StyledDemoAccordionItem,
  DemoAccordionTrigger,
  DemoAccordionContent,
  StyledDemoAccordionContentText,
} from "../StoryStyles/AccordionStyles";

const StyledAccordionExample = () => {
  return (
    <StyledDemoAccordion type="single" defaultValue="item-1" collapsible>
      <StyledDemoAccordionItem value="item-1">
        <DemoAccordionTrigger>Is it accessible?</DemoAccordionTrigger>
        <DemoAccordionContent>
          Yes. It adheres to the WAI-ARIA design pattern.
        </DemoAccordionContent>
      </StyledDemoAccordionItem>

      <StyledDemoAccordionItem value="item-2">
        <DemoAccordionTrigger>Is it unstyled?</DemoAccordionTrigger>
        <DemoAccordionContent>
          Yes. It's unstyled by default, giving you freedom over the look and
          feel.
        </DemoAccordionContent>
      </StyledDemoAccordionItem>

      <StyledDemoAccordionItem value="item-3">
        <DemoAccordionTrigger>Can it be animated?</DemoAccordionTrigger>
        <DemoAccordionContent>
          <StyledDemoAccordionContentText>
            Yes! You can animate the Accordion with CSS or JavaScript.
          </StyledDemoAccordionContentText>
        </DemoAccordionContent>
      </StyledDemoAccordionItem>
    </StyledDemoAccordion>
  );
};
export default StyledAccordionExample;
